import { AsyncPipe, NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import {
    AfterViewInit,
    Component,
    DestroyRef,
    ElementRef,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewChild,
    computed,
    effect,
    inject,
    input,
    signal,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterOutlet } from '@angular/router';

import {
    CacheManagerService,
    CasinoCoreGameLaunchFactoryService,
    CasinoCoreGamelaunchService,
    CasinoLobbyService,
    CasinoManager,
    ConfigProviderService,
    ConstService,
    FavouriteService,
    GameManagerService,
    GlobalTranslateComponent,
    HeaderVisibilityOnScrollService,
    LazySearchDesktopComponent,
    NativeApiService,
    NativeAppHelperService,
    RecentGamesService,
    SearchSectionService,
    SignPostingService,
    SlotRacesService,
    SmartBannerService,
} from '@casinocore/platform/core';
import {
    BottomNavService,
    DeviceService,
    DslPipe,
    DslService,
    HeaderService,
    MenuItemsService,
    MenuSection,
    NativeAppService,
    NavigationService,
    Page,
    TrackingService,
    UserLoginEvent,
    UserService,
    WindowRef,
} from '@frontend/vanilla/core';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ThumbnailNewgameComponent } from '../thumbnail-newgame/thumbnail-newgame.component';
import { NavNewsFeedComponent } from './nav-news-feed/nav-news-feed.component';
import { PillSubNavigationComponent } from './pill-sub-navigation/pill-sub-navigation.component';

@Component({
    selector: 'cc-navigation-bar',
    templateUrl: 'navigation-bar.component.html',
    host: { '(document:click)': 'hideMoreCategoryDropdown(true)', '[style.top.px]': 'subNavigationTop()' },
    imports: [
        NgIf,
        NgClass,
        NgFor,
        NgStyle,
        RouterLink,
        ThumbnailNewgameComponent,
        GlobalTranslateComponent,
        RouterOutlet,
        AsyncPipe,
        DslPipe,
        LazySearchDesktopComponent,
        PillSubNavigationComponent,
        NavNewsFeedComponent,
    ],
})
export class NavigationBarComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    @ViewChild('deskNav') deskNav: ElementRef;
    @ViewChild('mobilenavItems') mobileNavigation: ElementRef;
    @ViewChild('fixedtabdev') fixedtabdev: ElementRef;
    @ViewChild('cssearchcomponent') cssearchcomponent: ElementRef;
    @ViewChild('pillSubNav') pillSubNavComponent: PillSubNavigationComponent;

    @Input() lobbyType: string;
    @Input() categoryRoute: string;
    @Input() lobbyProduct: string;
    @Input() productOverride: string;
    @Input() stickyInputQueryElement: string;
    extendMenuDslEvalCompleted = input<boolean>(false);
    lobbyLoadSubscription: Subscription;
    isLobbyLoaded = signal<boolean>(false);

    readonly innerWidth: number = this.deviceService.windowWidth();
    isNewsFeedEnabled: boolean;
    newsFeedPosition: string;
    isNewsFeedEnabledOnHome: boolean;
    moreclassVariable: any;
    navItems: any = [];
    defaultCategoryType: any;
    myNavCategories: any;
    categoryType: any;
    defaultPageText: string;
    slotRacesNavSubscription: Subscription;
    isTouch: boolean;
    moreCategories: any[] = [];
    hideMore: boolean = true;
    showHomeInTopNavigation: boolean;
    fixednavEnabled: boolean;
    isMoreActive: boolean = false;
    smartBannersExists: boolean;
    smartBannerOpened: boolean;
    isMobile: boolean;
    orientation: any;
    showHomeFixedNavigation: boolean;
    enableVnIconsForPills: boolean;
    showLastLevelCategoryDropdown: boolean = false;
    isMobileWidth = computed(() => this.deviceService.isMobileWidth() || this.deviceService.isTouch);
    favouritesCategoryIndex: number = -1;
    recentsCategoryIndex = -1;
    slotRacesCategoryIndex = -1;
    tempArray: any = [];
    displayDiscoverSticker: boolean = false;
    categoryStickerName: string = '';
    isBadgeTypeIcon: boolean;
    isBadgeTypeText: boolean;
    badgeIcon: string = '';
    badgeColor: string = '';
    badgeTextColor: string = '';
    showGlobalSearch: boolean;
    useFavouriteGames: boolean;
    extendTopMenuState: boolean;
    navGlobalSearchEnabled: boolean;
    extendTopMenu: any;
    defaultProductHomeUrl: string;
    extendedTopMenuToRight: boolean;
    enableDefaultHomeUrl: boolean;
    searchText: string = '';
    showSearchInTopNavigation: boolean;
    promotionLinkText: string = '';
    promotionLinkUrl: string;
    categoryHeaderHighLight: any;
    discoverFeedLmtkey: string;
    enableDiscoverFeed: boolean;
    currentCategoryInfo: any;
    isDefaultCategory: boolean;
    subNavConfigEnabledCondition: string;
    subNavConfigEnableDesktopIcon: boolean;
    enableSubNav: boolean;
    favObs: Subscription;
    smartBannerStatusObs: Subscription;
    smartBannerExistsObs: Subscription;
    recentObs: Subscription;
    userUpdateObs: Subscription;
    casinoLobbyObs: Subscription;
    discoverFeedStickerObs: Subscription;
    isSignPosting: boolean;
    enableFixedMobileNavigation: boolean;
    enablePreLoginRecentlyPlayed: boolean;
    navBarLimitTimeout: number;
    isPromotionPagesEnabled: boolean;
    mcPageDefaultHomePageUrl: string = '';
    hideHomeInSubNav: boolean;
    feature: any;
    thumbnailConfig: any;
    isThumnbailEnabled: boolean = false;
    isThumbnailEnabledforLobby: any;
    thumbnailVisible: boolean = false;
    displayThumbnailDesktop: boolean = false;
    displayThumbnailMobile: boolean = true;
    arrowPosition: number;
    categorySelected: any;
    thumbnailgame: string = '';
    slotracesKey: string = '';
    isSlotRacesEnabled: boolean;
    thumbnailArrowColorConfig: any;
    isVipUser: boolean;
    slotRacesConfig: any;
    currentUrl: any;
    ForceMobileNav: boolean;
    headerServiceObservable: Subscription;
    moreIcon: string;
    instaStoriesDataObj: any;
    enableSubNavigationBgColor: boolean;
    subNavConfigEnableIconTextColor: boolean;
    navIndex: number = 0;
    navItemsActive: any[];
    navTopMenuItems: any[];
    enableTopNavStyling: boolean;
    listItems: any;
    totalWidth: number;
    listItemsPadding: number = 16;
    isDesktopNav: boolean;
    rightMove: number;
    currentActiveCategory: any;
    activeCategoryDimensions: any;
    showEpcotNavLeftScrollButton: boolean;
    showEpcotNavRightScrollButton: boolean;
    enablePillsSubNavigation: boolean;
    featureConfig: any;
    enableIndexIncrementOnSearch: boolean;
    extendedTopWithNavItems: any;
    isInverse: boolean = true;
    navItemExistsInNavigationCategory: any;
    private DEFAULT_OFFSET: number = 200;
    selectedUrl = false;
    private hideHeaderOnScroll = signal(false);
    private headerVisibilityOnScrollService = inject(HeaderVisibilityOnScrollService);
    private readonly hasHeaderElement = toSignal(this.headerService.whenReady.pipe(map(() => this.headerService.hasHeaderElement())));
    private readonly headerElementHeight = computed(() => (this.hasHeaderElement() ? this.headerService.headerElementRect().height : 0));
    readonly subNavigationTop = computed(() => {
        return this.headerElementHeight() + this.smartBannerService.smartBannerRect().height;
    });
    private destroyRef = inject(DestroyRef);

    constructor(
        private navigation: NavigationService,
        private configProviderService: ConfigProviderService,
        private nativeApplication: NativeAppService,
        private casinoManager: CasinoManager,
        private favouriteService: FavouriteService,
        private recentGamesService: RecentGamesService,
        private searchSection: SearchSectionService,
        private nativeApi: NativeApiService,
        private NativeAppHelper: NativeAppHelperService,
        private m2Page: Page,
        private deviceService: DeviceService,
        private user: UserService,
        private smartBannerService: SmartBannerService,
        private tracking: TrackingService,
        private navigationBar: ElementRef,
        private headerService: HeaderService,
        private bottomNavService: BottomNavService,
        private windowRef: WindowRef,
        private cacheManager: CacheManagerService,
        private page: Page,
        private signPostingService: SignPostingService,
        private slotRacesService: SlotRacesService,
        private dslService: DslService,
        private casinoLobbyService: CasinoLobbyService,
        private gamelaunchservice: CasinoCoreGamelaunchService,
        private gameLaunchFactoryService: CasinoCoreGameLaunchFactoryService,
        private menuService: MenuItemsService,
        private gameManagerService: GameManagerService,
    ) {
        this.gameLaunchFactoryService.setGameLaunchService(this.gamelaunchservice);
        effect(() => {
            const subNavStickyOffsetTop = this.subNavigationTop();
            if (subNavStickyOffsetTop != null && !this.hideHeaderOnScroll()) {
                if (
                    document.getElementsByTagName(this.stickyInputQueryElement) &&
                    document.getElementsByTagName(this.stickyInputQueryElement).length > 0
                ) {
                    const navSectionelement: any = document.getElementsByTagName(this.stickyInputQueryElement)[0];
                    navSectionelement.style.top = subNavStickyOffsetTop - 1 + 'px';
                }
            }
        });
        const initializeStickyHeaderEffect = effect(() => {
            if (this.hideHeaderOnScroll() && this.hasHeaderElement()) {
                this.headerVisibilityOnScrollService.initializeStickyBehavior();
                initializeStickyHeaderEffect.destroy();
            }
        });
    }

    assignFeatures() {
        const features: any = this.configProviderService.provideFeaturesConfig();
        this.slotRacesConfig = this.configProviderService.provideSlotRacesConfig();
        this.feature = features;
        this.thumbnailConfig = this.configProviderService.provideThumbnailConfig();
        this.isThumnbailEnabled = this.thumbnailConfig.enableGameThumbnail;
        this.isThumbnailEnabledforLobby = this.casinoManager.IsFeatureEnabledforLobbytype(
            this.lobbyType,
            this.thumbnailConfig.isGameThumbnailsVisible,
        );

        this.isVipUser = this.user.claims.get('vipLevel') != null;

        this.useFavouriteGames = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, features.favouriteGamesLobbyType);
        this.isSignPosting = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, features.enableSignpostingSticker);

        const lmtDataConfig: any = this.configProviderService.provideLmtConfig();
        this.enableDefaultHomeUrl = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, lmtDataConfig.enableDefaultHomeUrl);
        this.defaultProductHomeUrl = lmtDataConfig.defaultProductHomeUrl ? lmtDataConfig.defaultProductHomeUrl : '';
        const discoverConfig: any = this.configProviderService.provideDiscoverFeedConfig();
        this.discoverFeedLmtkey = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, discoverConfig.discoverFeedLmtkey);
        this.evalSubNavDisplay(this.subNavConfigEnabledCondition);
        const newsFeedConfig = this.configProviderService.provideNewsFeedCasinoConfig();
        if (newsFeedConfig) {
            this.isNewsFeedEnabled = newsFeedConfig.isEnabled;
            this.isNewsFeedEnabledOnHome = newsFeedConfig.isEnabledOnHomeCategory;
            this.newsFeedPosition = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, newsFeedConfig.newsFeedPosition);
        }
        this.hideHeaderOnScroll.set(!!features.hideHeaderOnScroll);
    }

    thumbnailArrowColor(thumbnail: any): any {
        this.thumbnailArrowColorConfig = this.thumbnailConfig.thumbnailConfigurations;
        if (thumbnail.isVipThumbnail) {
            return { 'border-bottom-color': this.thumbnailArrowColorConfig.VIPThumbnailColor };
        } else {
            return { 'border-bottom-color': this.thumbnailArrowColorConfig.AnonymousThumbnailColor };
        }
    }

    assignConfigs() {
        this.slotRacesConfig = this.configProviderService.provideSlotRacesConfig();
        const features: any = this.configProviderService.provideFeaturesConfig();
        this.featureConfig = this.configProviderService.provideFeaturesConfig();
        this.showGlobalSearch = features.showGlobalSearch;
        this.extendTopMenuState = features.extendedTopMenuStatus;
        this.navGlobalSearchEnabled = features.globalSearchFixedNavMobile;
        this.extendedTopMenuToRight = features.extendedTopMenuToRight;
        this.showSearchInTopNavigation = features.showSearchInTopNavigation;
        this.showHomeInTopNavigation = features.showHomeInTopNavigation;
        this.showHomeFixedNavigation = features.showHomeFixedNavigation;
        this.categoryHeaderHighLight = features.highlightCategoryHeader;
        this.enableFixedMobileNavigation = features.enableFixedMobileNavigation;
        this.enablePreLoginRecentlyPlayed = features.enablePreLoginRecentlyPlayed;
        this.navBarLimitTimeout = features.setNavBarLimitTimeout;
        this.isPromotionPagesEnabled = features.isPromotionPagesEnabled;
        this.hideHomeInSubNav = features.hideHomeInSubNav;

        const mcPage: any = this.configProviderService.provideMcPageConfig();
        this.extendTopMenu = mcPage.extendTopMenu;
        this.addingPathNameInExtendTopMenu();
        this.defaultPageText = mcPage.defaultPage;
        this.mcPageDefaultHomePageUrl = mcPage.defaultHomePage?.url || '';

        const global: any = this.configProviderService.provideGlobalConfig();
        this.searchText = global.messages.Search;
        this.moreIcon = global.lobbyConfigurations.moreIcon;

        const promotionsInfoConfig: any = this.configProviderService.providePromotionsInfoConfig();
        this.promotionLinkText = promotionsInfoConfig.promotionPageLink.text;
        this.promotionLinkUrl = promotionsInfoConfig.promotionPageLink.url;

        const discoverConfig: any = this.configProviderService.provideDiscoverFeedConfig();
        this.enableDiscoverFeed = discoverConfig.enableDiscoverFeed;
        const subNavigationConfig: any = this.configProviderService.provideSubNavigationConfig();
        this.subNavConfigEnabledCondition = subNavigationConfig.isEnabledCondition;
        this.subNavConfigEnableDesktopIcon = subNavigationConfig.enableDesktopIcon;
        this.enableSubNavigationBgColor = subNavigationConfig.enableSubNavigationBgColor;
        this.subNavConfigEnableIconTextColor = subNavigationConfig.enableIconTextColor;
    }

    ngOnInit(): void {
        this.lobbyLoadSubscription = this.casinoLobbyService.lobbyLoadedObservable.subscribe((response) => {
            if (response) {
                this.isLobbyLoaded.set(true);
            }
        });

        this.assignConfigs();
        this.assignFeatures();
        this.onLobbyChange();
        this.LobbySubscriptions();
        const features = this.configProviderService.provideFeaturesConfig();
        const { multiLabelConfiguration, enableMultiLabelConfiguration } = features;
        if (enableMultiLabelConfiguration) {
            const labelConfig = multiLabelConfiguration[window.location.host];
            this.selectedUrl = labelConfig ? true : false;
        }
        this.isTouch = this.deviceService.isTouch;
        this.orientation = this.deviceService.orientation;

        this.isMobile = this.deviceService.windowWidth() < 768;
        this.categoryType = this.casinoManager.getActiveCategory();

        this.fixednavEnabled = this.NativeAppHelper.isNativeFeatureEnabled(this.NativeAppHelper.nativeAppFeatures.fixednav);

        if (this.navigation.location.path() === '/' || this.navigation.location.path() === '/' + this.page.lang) {
            this.tracking.updateDataLayer({
                'page.referrer': this.windowRef.nativeWindow.document.referrer,
                'page.url': this.navigation.location.absUrl(),
                'page.host': this.navigation.location.host(),
                'page.name': this.casinoManager.getProductForGivenLobbyType(this.lobbyType),
                'page.responsive': true,
            });
        }
        const lmtDataConfig: any = this.configProviderService.provideLmtConfig();
        this.currentUrl = this.navigation.location.baseUrl() + this.navigation.location.path();
        this.ForceMobileNav = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, lmtDataConfig.lobbyTypeMap);
        if (document.getElementsByTagName('html')[0].classList.contains('casino-sub-nav-thumbnail')) {
            document.getElementsByTagName('html')[0].classList.remove('casino-sub-nav-thumbnail');
        }
        if (this.isTouch) {
            this.isDesktopNav = false;
        } else {
            this.isDesktopNav = true;
        }
        //show search in navigation boolean set
        this.enableIndexIncrementOnSearch = this.isTouch || this.enablePillsSubNavigation;
        this.user.events
            .pipe(filter((e) => e instanceof UserLoginEvent))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.onLobbyChange();
            });
    }

    setSlotRacesConfigs(): void {
        this.slotracesKey = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, this.slotRacesConfig.slotRacesLMTCategoryIdForLobbyType);
        this.isSlotRacesEnabled = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, this.feature.enableSlotRacesForLobbyType);
        if (this.isSlotRacesEnabled && this.slotRacesConfig.disableWhenNoPromotions) {
            this.slotRacesNavSubscription = this.slotRacesService.updateNavigation
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((update: boolean) => {
                    if (update) {
                        this.updateNavItems();
                    }
                });
        }
    }
    addingPathNameInExtendTopMenu() {
        this.extendTopMenu.forEach((data: any) => {
            if (this.isRelativeURL(data.url)) {
                data.pathname = new URL(data.url).pathname;
                if (data.pathname?.split('/')[2] === 'blog') {
                    data.pathname = '';
                }
            }
        });
    }

    onLobbyChange() {
        this.setDefaultCategoryInfo();
        this.assignNavItems();
        this.setCurrentCategoryInfo();
        this.setVanillaActiveHeader();
    }
    checkforThumnbail(currentCategory: any) {
        if (this.isThumnbailEnabled && this.isThumbnailEnabledforLobby) {
            const thumbnail = this.casinoLobbyService.getThumbnailbasedonroute(currentCategory);
            if (thumbnail) {
                const game = thumbnail.gameId;
                if (game != this.cacheManager.getThumbnailsfromLocalStorage(this.lobbyType)) {
                    this.displayThumbnailDesktop = true;
                }
            } else {
                this.displayThumbnailDesktop = false;
            }
        }
    }

    onRouteChange() {
        this.setCurrentCategoryInfo();
        this.setVanillaActiveHeader();
        if (this.navItems && this.navItems.length > 0) {
            this.assignThumbnailPropertyandsignposting();
        } else {
            this.assignNavItems();
            this.assignThumbnailPropertyandsignposting();
        }
        this.highlightActiveCategory();
    }

    highlightActiveCategory() {
        this.setActiveMobile(this.categoryRoute);
        if (this.deviceService.windowWidth() >= 768) {
            setTimeout(() => {
                this.setActiveCategory();
            }, 100);
        }
    }

    assignNavItems() {
        const subNavconfig = this.configProviderService.provideSubNavigationConfig();
        this.enablePillsSubNavigation = subNavconfig.enablePillsSubNavigation;
        this.enableTopNavStyling = subNavconfig.enableTopNavStyling;
        this.enableVnIconsForPills = !!subNavconfig.enableVnIconsForPills;
        const categoriesfromCache: any = this.casinoLobbyService.getNavCategories(this.lobbyType, this.productOverride);
        if (categoriesfromCache && categoriesfromCache.length > 0) {
            this.navItems = [];
            for (let i = 0; i < categoriesfromCache.length; i++) {
                const category: any = cloneDeep(categoriesfromCache[i]);
                //    let category: any = {...categoriesfromCache[i]};
                if (
                    category.isdefault &&
                    this.enableDefaultHomeUrl &&
                    category?.categoryid?.toLowerCase() === this.defaultProductHomeUrl?.toLowerCase()
                ) {
                    category.url = '/';
                }
                if (this.isRelativeURL(category.url)) {
                    category.pathname = new URL(category.url).pathname;
                    if (category.pathname?.split('/')[2] === 'blog') {
                        category.pathname = '';
                    }
                }
                if (this.checkIfShowInNavigation(category)) {
                    this.navItems.push(category);
                }
            }
            if (this.extendTopMenuState && this.extendedTopMenuToRight) {
                this.topMenuItemsToend();
            }
        }
    }

    prepareTopNavigation() {
        this.navTopMenuItems = [];
        this.navItemsActive = [];
        let category: any = [];
        this.navIndex = 0;
        if (this.showSearchInTopNavigation && this.enableIndexIncrementOnSearch) {
            category.index = this.navIndex + 1;
            this.navIndex = category.index;
            category.categoryType = this.searchText;
            category.Flagname = 'showSearchInTopNavigation';
            this.navTopMenuItems.push(category);
        } else if (this.showHomeFixedNavigation) {
            category = [];
            category.index = this.navIndex + 1;
            this.navIndex = category.index;
            category.categoryType = this.defaultPageText;
            category.Flagname = 'showHomeFixedNavigation';
            this.navTopMenuItems.push(category);
        } else if (this.fixednavEnabled && this.showHomeInTopNavigation) {
            category = [];
            category.index = this.navIndex + 1;
            this.navIndex = category.index;
            category.categoryType = this.defaultPageText;
            category.Flagname = 'fixednavEnabled';
            this.navTopMenuItems.push(category);
        } else if (this.isPromotionPagesEnabled) {
            category = [];
            category.index = this.navIndex + 1;
            this.navIndex = category.index;
            category.categoryType = this.promotionLinkText;
            category.Flagname = 'isPromotionPagesEnabled';
            this.navTopMenuItems.push(category);
        }
        if (this.extendTopMenuState && !this.extendedTopMenuToRight && this.extendTopMenu && this.extendTopMenu.length > 0) {
            const mcPage: any = this.configProviderService.provideMcPageConfig();
            this.extendTopMenu = mcPage.extendTopMenu;
            this.extendTopMenu.forEach((topmenu: any) => {
                category = [];
                if (this.isRelativeURL(topmenu.url)) {
                    category.pathname = new URL(topmenu.url).pathname;
                    if (category.pathname?.split('/')[2] === 'blog') {
                        category.pathname = '';
                    }
                }
                category.categoryType = topmenu.title;
                category.url = topmenu.url;
                category.Flagname = 'extendTopMenuState';
                topmenu.showInNavExtendedTopMenu = this.showInNavExtendedTopMenu(topmenu);
                if (category.categoryType && topmenu.dslResult && topmenu.showInNavExtendedTopMenu) {
                    category.index = this.navIndex + 1;
                    this.navIndex = category.index;
                    this.navTopMenuItems.push(category);
                }
            });
            this.extendTopMenu = JSON.parse(
                JSON.stringify(
                    this.extendTopMenu.filter((item: any) => {
                        return item.showInNavExtendedTopMenu;
                    }),
                ),
            );
        }
        if (this.extendTopMenuState && this.extendedTopMenuToRight) {
            this.topMenuItemsToend();
        }
        this.navItemExistsInNavigationCategory = this.navItems.filter((x: any) => x.isNavigationCategory === true);
        this.extendedTopWithNavItems = this.navTopMenuItems.concat(this.navItemExistsInNavigationCategory);
        this.gamelaunchservice.setGameLaunchNavItems(this.extendedTopWithNavItems);
    }

    showInNavExtendedTopMenu(category: any) {
        if (category.name.toLowerCase() == ConstService.RECENT_GAMES_CATEGORY_ID.toLowerCase()) {
            if (this.recentGamesService.getrecentGames() && this.recentGamesService.getrecentGames().length === 0) return false;
            else if (this.recentGamesService.getrecentGames() && this.recentGamesService.getrecentGames().length > 0 && this.user.isAuthenticated)
                return true;
            else return false;
        } else if (category.name.toLowerCase() == ConstService.FAVOURITE_GAMES_CATEGORY_ID.toLowerCase()) {
            if (this.favouriteService.favouriteGames && this.favouriteService.favouriteGames.length === 0) return false;
            else if (this.favouriteService.favouriteGames && this.favouriteService.favouriteGames.length > 0 && this.useFavouriteGames) return true;
            else return false;
        }
        return true;
    }

    isRelativeURL(url: string) {
        return url.includes(window.location.host);
    }

    topMenuItemsToend() {
        const mcPage: any = this.configProviderService.provideMcPageConfig();
        this.extendTopMenu = mcPage.extendTopMenu;
        this.navItems = this.navItems.filter((item: any) => {
            return !item.isExtendedTopMenuItem;
        });
        if (this.extendTopMenu && this.extendTopMenu.length > 0) {
            let menuItems: ExtendedTopMenutoRight = new ExtendedTopMenutoRight();
            this.extendTopMenu.forEach((item: any) => {
                menuItems = new ExtendedTopMenutoRight();
                menuItems.sitecoreData = {};
                if (this.isRelativeURL(item.url)) {
                    menuItems.pathname = new URL(item.url).pathname;
                    if (menuItems.pathname?.split('/')[2] === 'blog') {
                        menuItems.pathname = '';
                    }
                }
                menuItems.url = item.url;
                menuItems.categoryid = item.title;
                menuItems.categoryname = item.title;
                menuItems.isNavigationCategory = true;
                menuItems.sitecoreData.categoryId = item.title;
                menuItems.sitecoreData.attributes = {};
                menuItems.sitecoreData.attributes.icon = item.cssClass;
                menuItems.condition = item.condition;
                menuItems.fromExtendedMenuRight = true;
                menuItems.categoryType = item.title;
                menuItems.Flagname = 'extendTopMenuRightState';
                menuItems.showInNavExtendedTopMenu = this.showInNavExtendedTopMenu(item);
                menuItems.isNavigationCategory = menuItems.showInNavExtendedTopMenu;
                if (menuItems.sitecoreData.categoryId && item.dslResult) {
                    this.navItems.push(menuItems);
                }
            });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.assignFeatures();
        this.onRouteChange();
        this.isTouch = this.deviceService.isTouch;
        if (changes.lobbyType || changes.lobbyProduct) {
            this.setSlotRacesConfigs();
        }
    }

    setCurrentCategoryInfo() {
        const currentCategory = this.casinoLobbyService.getCategoryInfo(this.lobbyType, this.categoryRoute);
        if (currentCategory && currentCategory.categoryInfo) {
            this.categorySelected = currentCategory.categoryInfo.categoryid;
            this.categoryType = this.categorySelected;
            this.currentCategoryInfo = currentCategory.categoryInfo;
            this.checkforThumnbail(this.currentCategoryInfo);
        }
    }

    setDefaultCategoryInfo() {
        this.defaultCategoryType = this.casinoLobbyService.getDefaultOrFirstCategoryInfo(this.lobbyType)?.categoryInfo;
        this.isDefaultCategory = this.defaultCategoryType && this.defaultCategoryType.categoryid === this.categoryRoute;
    }

    LobbySubscriptions() {
        this.smartBannerStatusObs = this.smartBannerService.smartBannerStatusObservable
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((isOpened) => {
                this.smartBannerStatusChanged(isOpened);
            });
        this.smartBannerExistsObs = this.smartBannerService.smartBannersExistsObservable
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((isSbListExists) => {
                this.smartBannerListExistsChanged(isSbListExists);
            });
        this.favObs = this.favouriteService.favouriteGamesFeedObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((favouriteGames) => {
            if (favouriteGames) {
                this.getAvailableGames(favouriteGames, this.favouritesCategoryIndex);
                this.updateNavItems();
            }
        });
        this.recentObs = this.recentGamesService.recentGamesFeedObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((recentGames) => {
            if (recentGames) {
                this.getAvailableGames(recentGames, this.recentsCategoryIndex);
                this.updateNavItems();
            } else {
                if (this.enablePreLoginRecentlyPlayed) {
                    this.updateNavItems();
                }
            }
        });
        if (!this.user.isAuthenticated) {
            this.casinoLobbyObs = this.casinoLobbyService.lobbyLoadedObservable
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((lobbyTypeMaps) => {
                    if (this.user.isAuthenticated && lobbyTypeMaps && lobbyTypeMaps.size > 0) {
                        this.onLobbyChange();
                        this.updateNavItems();
                    }
                });
        }
    }

    checkIfShowInNavigation(category: any): boolean {
        if (category.categoryid && category.categoryid?.toLowerCase() === ConstService.RECENT_GAMES_CATEGORY_ID) {
            return true;
        }
        if (
            this.useFavouriteGames &&
            category.categoryid &&
            category.categoryid.toUpperCase() === ConstService.FAVOURITE_GAMES_CATEGORY_ID.toUpperCase()
        ) {
            return true;
        }
        if (
            category.isNavigationCategory &&
            category.categoryid !== this.slotracesKey &&
            ((category.lmtSubCategories && category.lmtSubCategories.length > 0) || (category.gamelist && category.gamelist.length > 0))
        ) {
            return true;
        }
        if (this.enableDiscoverFeed && this.discoverFeedLmtkey) {
            if (this.discoverFeedLmtkey?.toLowerCase() == category?.categoryid?.toLowerCase()) {
                return true;
            }
        }
        if (this.isSlotRacesEnabled) {
            if (this.slotracesKey == category.categoryid) {
                return true;
            }
        }
        return false;
    }

    ngOnDestroy() {
        if (this.slotRacesNavSubscription) {
            this.slotRacesNavSubscription.unsubscribe();
        }
        if (this.smartBannerStatusObs) {
            this.smartBannerStatusObs.unsubscribe();
        }
        if (this.smartBannerExistsObs) {
            this.smartBannerExistsObs.unsubscribe();
        }
        if (this.recentObs) {
            this.recentObs.unsubscribe();
        }
        if (this.headerServiceObservable) {
            this.headerServiceObservable.unsubscribe();
        }
        if (this.favObs) {
            this.favObs.unsubscribe();
        }
        if (this.casinoLobbyObs) {
            this.casinoLobbyObs.unsubscribe();
        }
        if (this.discoverFeedStickerObs) {
            this.discoverFeedStickerObs.unsubscribe();
        }
        this.lobbyLoadSubscription?.unsubscribe();
    }

    ngAfterViewInit() {
        this.updateNavItems();
        setTimeout(() => {
            if (this.isTouch && this.orientation && this.orientation._value == 'landscape') {
                this.adjustNavOnLandscapeMode();
            }
            this.thumbnailScroll();
            if (document.getElementsByClassName('nav-li nav-item') && this.isDesktopNav) {
                this.listItems = document.getElementsByClassName('nav-li nav-item');
                this.totalWidth = 0;
                for (let i = 0; i < this.listItems.length; i++) {
                    if (!this.listItems[i].hidden) {
                        this.totalWidth += this.listItemsPadding;
                        this.totalWidth += this.listItems[i].offsetWidth;
                    }
                }
            }
        }, 1500);
        if (this.deviceService.isTouch) {
            this.deferAdjustNavScroll();
        }
    }

    assignNavCategories() {
        this.prepareTopNavigation();
        if (this.navItems) {
            this.myNavCategories = this.navItems.filter((navItem: any) => {
                return navItem.isNavigationCategory;
            });
            this.myNavCategories.forEach((category: any) => {
                category.index = this.navIndex + 1;
                this.navIndex = category.index;
            });
            this.navIndex = 0;
        }
        setTimeout(() => {
            if (this.deviceService.windowWidth() >= 768) {
                this.checkNavBarCategoryLimit();
            }
            setTimeout(() => {
                this.setActiveCategory();
            }, 50);
        }, this.navBarLimitTimeout);
    }

    shouldShowDesktopSubNavigation(): boolean {
        return !this.enablePillsSubNavigation && !this.isMobile;
    }

    shouldShowMobileSubNavigation(): boolean {
        return !this.enablePillsSubNavigation && this.isMobile;
    }

    setRecentsCategoryIndex() {
        if (this.navItems) {
            this.recentsCategoryIndex = this.navItems.indexOf(
                this.navItems.filter((c: any) => c?.categoryid?.toLowerCase() === ConstService.RECENT_GAMES_CATEGORY_ID)[0],
            );
        } else {
            this.recentsCategoryIndex = -1;
        }
    }

    setFavouritesCategoryIndex() {
        if (this.navItems) {
            this.favouritesCategoryIndex = this.navItems.indexOf(
                this.navItems.filter((c: any) => c?.categoryid?.toLowerCase() === ConstService.FAVOURITE_GAMES_CATEGORY_ID)[0],
            );
        } else {
            this.favouritesCategoryIndex = -1;
        }
    }

    updateNavItems() {
        this.setRecentsCategoryIndex();
        this.setFavouritesCategoryIndex();
        const subNavconfig = this.configProviderService.provideSubNavigationConfig();
        const showFavInSubNav = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, subNavconfig.showFavInSubNav);
        const showRecentInSubNav = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, subNavconfig.showRecentInSubNav);
        if (this.favouritesCategoryIndex > -1 && this.navItems[this.favouritesCategoryIndex]) {
            this.navItems[this.favouritesCategoryIndex].isNavigationCategory = false;
        }
        this.navItemCategory();
        this.navItemGameSerivce();
        if (!showRecentInSubNav && this.navItems && this.navItems[this.recentsCategoryIndex]) {
            this.navItems[this.recentsCategoryIndex].isNavigationCategory = false;
        }
        if (!showFavInSubNav && this.navItems && this.navItems[this.favouritesCategoryIndex]) {
            this.navItems[this.favouritesCategoryIndex].isNavigationCategory = false;
        }
        this.slotRacesCategoryIndex = this.navItems.indexOf(this.navItems.filter((c: any) => c.categoryid === this.slotracesKey)[0]);
        const slotRacesData = this.slotRacesService.getCurrentRaces();

        if (this.isSlotRacesEnabled && this.slotRacesCategoryIndex > -1) {
            if (this.slotRacesConfig.disableWhenNoPromotions) {
                if (slotRacesData?.liveNow?.length || slotRacesData?.upcomingToday?.length || slotRacesData?.upcomingTomorrow?.length) {
                    this.navItems[this.slotRacesCategoryIndex].isNavigationCategory = true;
                } else {
                    this.navItems[this.slotRacesCategoryIndex].isNavigationCategory = false;
                }
            }
        }
        this.assignNavCategories();
        this.assignThumbnailPropertyandsignposting();
        this.thumbnailScroll();
        setTimeout(() => {
            this.setActiveMobile(this.categoryRoute);
            this.pillSubNavComponent?.adjustEpcotNavContainerScroll();
        }, 50);
    }
    navItemCategory() {
        if (!this.user.isAuthenticated) {
            if (this.navItems && this.navItems[this.recentsCategoryIndex]) {
                this.navItems[this.recentsCategoryIndex].isNavigationCategory = false;
            }
            if (this.navItems && this.navItems[this.favouritesCategoryIndex]) {
                this.navItems[this.favouritesCategoryIndex].isNavigationCategory = false;
            }
        }
    }
    navItemGameSerivce() {
        if (this.recentGamesService.getrecentGames() && this.recentGamesService.getrecentGames().length === 0 && this.recentsCategoryIndex > -1)
            this.navItems[this.recentsCategoryIndex].isNavigationCategory = false;
        if (this.favouriteService.favouriteGames && this.favouriteService.favouriteGames.length === 0 && this.favouritesCategoryIndex > -1)
            this.navItems[this.favouritesCategoryIndex].isNavigationCategory = false;
        if (
            this.recentGamesService.getrecentGames() &&
            this.recentGamesService.getrecentGames().length > 0 &&
            this.recentsCategoryIndex > -1 &&
            this.user.isAuthenticated
        )
            this.navItems[this.recentsCategoryIndex].isNavigationCategory = true;
        if (
            this.favouriteService.favouriteGames &&
            this.favouriteService.favouriteGames.length > 0 &&
            this.favouritesCategoryIndex > -1 &&
            this.useFavouriteGames
        )
            this.navItems[this.favouritesCategoryIndex].isNavigationCategory = true;
    }
    assignThumbnailPropertyandsignposting() {
        if (this.isSignPosting || (this.isThumnbailEnabled && this.isThumbnailEnabledforLobby)) {
            this.navItems.forEach((navItem: any) => {
                if (
                    this.isSignPosting &&
                    navItem.isNavigationCategory &&
                    this.defaultCategoryType &&
                    this.defaultCategoryType.categoryid != navItem.categoryid
                ) {
                    navItem.signPostingCount = this.signPostingService.getSignPostingCount(
                        this.getSignPostingGames(navItem.categoryid),
                        this.recentGamesService.getrecentGames(),
                    );
                }
                if (this.isThumnbailEnabled && this.isThumbnailEnabledforLobby) {
                    const thumbnail = this.casinoLobbyService.getThumbnailbasedonroute(navItem);
                    if (thumbnail) {
                        navItem.displayThumbnail = true;
                        navItem.isVipThumbnail = thumbnail.isVipThumbnail;
                        this.thumbnailgame = thumbnail.gameId;
                        this.thumbnailArrowColor(thumbnail);
                    }
                    this.thumbnailHover();
                }
            });
        }
    }
    thumbnailHover() {
        if (!this.isTouch || (this.deviceService.windowWidth() >= 768 && this.isTouch)) {
            if (this.thumbnailgame != this.cacheManager.getThumbnailsfromLocalStorage(this.lobbyType)) {
                this.displayThumbnailDesktop = true;
                this.displayThumbnailMobile = false;
            } else {
                this.displayThumbnailDesktop = false;
            }
        } else {
            if (this.thumbnailgame != this.cacheManager.getThumbnailsfromLocalStorage(this.lobbyType)) {
                this.displayThumbnailDesktop = false;
                this.displayThumbnailMobile = true;
            }
        }
    }
    @HostListener('window:scroll', ['$event'])
    thumbnailScroll() {
        if (
            this.isThumnbailEnabled &&
            this.isThumbnailEnabledforLobby &&
            document.querySelectorAll('.thumbnailActive').length > 0 &&
            this.isMobileWidth()
        ) {
            let fixednavWidth: any, thumnailElm: any, rect: any, elemLeft: any, elemRight: any, isVisible: any;
            thumnailElm = document.querySelectorAll('.thumbnailActive')[0];

            if (document.getElementById('fixedtabdevmobile')) {
                fixednavWidth = document.getElementById('fixedtabdevmobile')?.offsetWidth;
            } else {
                fixednavWidth = 0;
            }
            rect = thumnailElm.getBoundingClientRect();
            elemLeft = rect.left;
            this.arrowPosition = rect.left + thumnailElm.clientWidth / 2 - 10;
            //this.arrowPosition = rect.left + thumnailElm.clientWidth + 70;
            elemRight = rect.right;
            isVisible = elemRight - fixednavWidth >= 0 && elemLeft <= this.deviceService.windowWidth();
            this.thumbnailVisible = isVisible;
        }
    }
    closeThumbnailBox(thumdnailData: any) {
        this.displayThumbnailMobile = this.displayThumbnailDesktop = thumdnailData;
    }

    getSignPostingGames(categoryid: any) {
        let allGames: any = [];
        let subCategoryGames: any = [];
        const allRedirectCategory = this.casinoLobbyService.getCategoryInfo(this.lobbyType, categoryid);
        if (
            allRedirectCategory &&
            allRedirectCategory.categoryInfo &&
            allRedirectCategory.categoryInfo.gamelist &&
            allRedirectCategory.categoryInfo.gamelist.length > 0
        ) {
            allGames = allRedirectCategory.categoryInfo.gamelist;
        }
        if (
            allRedirectCategory &&
            allRedirectCategory.categoryInfo &&
            allRedirectCategory.categoryInfo.lmtSubCategories &&
            allRedirectCategory.categoryInfo.lmtSubCategories.length > 0
        ) {
            for (let i = 0; i < allRedirectCategory.categoryInfo.lmtSubCategories.length; i++) {
                const sub: any = this.casinoLobbyService.getCategoryInfo(this.lobbyType, allRedirectCategory.categoryInfo.lmtSubCategories[i]);
                if (sub && sub.categoryInfo && sub.categoryInfo.gamelist && sub.categoryInfo.gamelist.length > 0) {
                    subCategoryGames = subCategoryGames.concat(sub.categoryInfo.gamelist);
                }
            }
        }
        if (subCategoryGames && subCategoryGames.length > 0) {
            allGames = allGames.concat(subCategoryGames);
        }
        return allGames;
    }
    userInLimboState() {
        return (this.user.workflowType || '0') !== '0';
    }
    getAvailableGames(gameslist: string[], categoryIndex: number): any {
        if (categoryIndex > -1 && gameslist && gameslist.length > 0) {
            let gamesAvailable: boolean = false;
            for (let i = 0; i < gameslist.length; i++) {
                const gameInfo: any = this.gameManagerService.getGameInfo(gameslist[i]);
                if (gameInfo) {
                    gamesAvailable = true;
                    break;
                }
            }
            if (this.navItems?.length > 0 && this.navItems[categoryIndex] && !this.navItems[categoryIndex].isNavigationCategory) {
                this.navItems[categoryIndex].isNavigationCategory = gamesAvailable;
            }
        }
    }

    //Previous Code Integrated
    showSearch() {
        this.navTopMenuItems.forEach((x) => {
            if (x.Flagname == 'showSearchInTopNavigation') {
                this.trackingEntireNavigation(x.index, x.categoryType);
            }
        });

        if (this.navGlobalSearchEnabled && this.isMobile) {
            dispatchEvent(new CustomEvent('gs:presentation:launchsearch', { detail: { launchChannel: 'mobile', launchedFrom: 'sub-nav' } }));
        } else {
            this.searchSection.setSearchVisibility(true);
        }
    }

    goToDefaultPage(flagname: string) {
        this.navTopMenuItems.forEach((x) => {
            if (x.Flagname == flagname) {
                this.trackingEntireNavigation(x.index, x.categoryType);
            }
        });
        if (
            this.nativeApplication.isNativeWrapper &&
            (this.nativeApplication.product === 'SPORTSBOOK' || this.nativeApplication.product === 'BETTING')
        ) {
            this.nativeApi.raiseNativeAppEvent(ConstService.SPORTS_HOME_ICON_EVENT);
        } else {
            this.navigation.goTo(this.mcPageDefaultHomePageUrl);
        }
    }

    goToUrl(url: any) {
        this.navTopMenuItems.forEach((x) => {
            const urlConditionCheck = this.featureConfig.enableTrackingEntireNavigation ? true : x.url == url;
            if (x.Flagname == 'extendTopMenuState' && urlConditionCheck) {
                this.trackingEntireNavigation(x.index, x.categoryType);
            }
        });
        this.navigation.goTo(url);
    }

    extentRightMenuTracking(url: string, catId: string) {
        const navCategories = this.isTouch ? this.navItems : this.myNavCategories;
        navCategories?.forEach((x: any) => {
            const urlConditionCheck = this.featureConfig.enableTrackingEntireNavigation ? true : x.url == url;
            if (x.Flagname == 'extendTopMenuRightState' && urlConditionCheck) {
                this.trackingEntireNavigation(x.index, x.categoryType);
            }
        });
        this.setActiveMobile(catId);
    }

    goToPromotionPage() {
        this.navTopMenuItems.forEach((x) => {
            if (x.Flagname == 'isPromotionPagesEnabled') {
                this.trackingEntireNavigation(x.index, x.categoryType);
            }
        });
        if (this.promotionLinkUrl === '') {
            this.promotionLinkUrl = this.m2Page?.homePage;
        }
        this.navigation.goTo(this.promotionLinkUrl);
        event!.stopPropagation();
    }
    moreHover(hideMore: boolean) {
        if (!this.isTouch) {
            this.hideMore = hideMore;
            event!.stopPropagation();
        }
    }
    moreMouseLeave() {
        this.hideMore = true;
    }
    overlayMouseEnter() {
        this.hideMore = false;
    }

    moreClick(event: any) {
        this.hideMore = !this.hideMore;
        event.stopPropagation();
    }

    checkNavBarCategoryLimit() {
        let eleWidth = 0;
        this.moreCategories = [];
        let desktopNavWidth: any;
        let navigationItems: any[] = [];
        let windowWidth = this.deviceService.windowWidth();
        let themeSearchWidth: number = 0;
        let themeSearchElement: any;
        let emptyspace: any = 0;

        const fixedBarWidth =
            this.fixedtabdev && this.fixedtabdev.nativeElement
                ? this.fixedtabdev.nativeElement.clientWidth + this.fixedtabdev.nativeElement.offsetLeft
                : 0;
        if (!fixedBarWidth && this.deskNav && this.deskNav.nativeElement.children[0].children) {
            emptyspace = this.deskNav.nativeElement.getBoundingClientRect().left * 2;
        }
        if (fixedBarWidth) {
            emptyspace = this.fixedtabdev.nativeElement.getBoundingClientRect().left * 2;
        }
        if (windowWidth >= 1319) {
            windowWidth = 1319;
            emptyspace = 0;
        }

        const searchElement = this.cssearchcomponent?.nativeElement.querySelector('.desktop-searchnav');
        if (this.cssearchcomponent?.nativeElement?.children[0]?.children[0] && searchElement) {
            if (searchElement?.firstElementChild?.firstElementChild) {
                themeSearchElement = searchElement.firstElementChild.firstElementChild;
                themeSearchWidth = themeSearchElement.offsetLeft + themeSearchElement.offsetWidth;
            }
            const searchClientWidth = searchElement.clientWidth > 192 ? 192 : searchElement.clientWidth;
            themeSearchWidth = themeSearchWidth > 192 ? 192 : themeSearchWidth;
            desktopNavWidth = windowWidth - (fixedBarWidth + searchClientWidth + themeSearchWidth + emptyspace);
        } else {
            desktopNavWidth = windowWidth - (fixedBarWidth + emptyspace);
        }

        if (this.deskNav) {
            navigationItems = this.deskNav.nativeElement.children[0].children;
        }

        if (navigationItems && navigationItems.length > 0) {
            this.myNavCategories = [];
            const filteredliItems: any[] = [];
            for (let i = 0; i < navigationItems.length; i++) {
                if (navigationItems[i].classList.contains('nav-li')) {
                    filteredliItems.push(navigationItems[i]);
                }
            }
            const onlyDisplayCat = this.navItems.filter((navItem: any) => {
                return navItem.isNavigationCategory;
            });
            for (let index = 0; index < filteredliItems.length; index++) {
                const itemWidth = filteredliItems[index].clientWidth > 450 ? 60 : filteredliItems[index].clientWidth; //added this condition to adjust the width of item on first load
                eleWidth = eleWidth + itemWidth;
                if (eleWidth < desktopNavWidth) {
                    for (let i = 0; i < onlyDisplayCat.length; i++) {
                        if (onlyDisplayCat[i]?.categoryid?.toLowerCase() === filteredliItems[index].id?.toLowerCase()) {
                            this.myNavCategories.push(onlyDisplayCat[i]);
                        }
                    }
                } else {
                    this.myNavCategories.pop();
                    this.tempArray = [];
                    for (let i = index - 1; i < onlyDisplayCat.length; i++) {
                        if (!this.user.isAuthenticated && onlyDisplayCat[i]) {
                            if (
                                onlyDisplayCat[i].isNavigationCategory &&
                                onlyDisplayCat[i]?.categoryid?.toLowerCase() !== ConstService.RECENT_GAMES_CATEGORY_ID &&
                                onlyDisplayCat[i].categoryid.toLowerCase !== ConstService.FAVOURITE_GAMES_CATEGORY_ID
                            ) {
                                if (this.extendTopMenuState && this.extendedTopMenuToRight) {
                                    const filteredItem = this.myNavCategories.filter(
                                        (navCategory: any) => navCategory?.categoryid?.toLowerCase() === onlyDisplayCat[i]?.categoryid?.toLowerCase(),
                                    );
                                    if (filteredItem && filteredItem.length == 0) {
                                        this.moreCategories.push(onlyDisplayCat[i]);
                                        this.tempArray.push(onlyDisplayCat[i]);
                                    }
                                } else {
                                    this.moreCategories.push(onlyDisplayCat[i]);
                                    this.tempArray.push(onlyDisplayCat[i]);
                                }
                            }
                        } else if (onlyDisplayCat[i]) {
                            this.moreCategories.push(onlyDisplayCat[i]);
                            this.tempArray.push(onlyDisplayCat[i]);
                        }
                    }
                    break;
                }
            }
            if (desktopNavWidth && windowWidth == 1319 && eleWidth >= desktopNavWidth - 100 && this.moreCategories.length == 0) {
                const lastElement = this.myNavCategories[this.myNavCategories.length - 1];
                this.myNavCategories.pop();
                this.moreCategories.push(lastElement);
                this.tempArray.push(lastElement);
            }
            if (this.tempArray.length > 0) {
                for (let i = 0; i < this.tempArray.length; i++) {
                    if (this.moreCategories.indexOf(this.tempArray[i]) === -1 && this.myNavCategories.indexOf(this.tempArray[i]) === -1) {
                        this.moreCategories.push(this.tempArray[i]);
                    }
                }
            }

            this.moreCategories = this.moreCategories.filter((item: any) => {
                return item.isNavigationCategory;
            });
            if (this.moreCategories.length > 0) {
                this.moreCategories = this.sortMoreCategories(onlyDisplayCat, this.moreCategories);
            }
            const filteredNavArray: any = this.navItems.filter((navItem: any) => {
                return navItem.isNavigationCategory;
            });
            let anyItemsLeftToPushIntoMore: boolean = false;
            if (filteredNavArray && filteredNavArray.length > 0) {
                anyItemsLeftToPushIntoMore = filteredliItems.length < filteredNavArray.length;
            }
            if (anyItemsLeftToPushIntoMore) {
                if (filteredliItems.length < onlyDisplayCat.length) {
                    for (let i = filteredliItems.length - 1; i < onlyDisplayCat.length; i++) {
                        if (onlyDisplayCat[i] && this.moreCategories.indexOf(onlyDisplayCat[i]) === -1) {
                            this.moreCategories.push(onlyDisplayCat[i]);
                        }
                    }
                }
            }
            this.moreCategories = this.moreCategories.filter((item: any) => {
                return item.isNavigationCategory;
            });
        }
        this.setActiveCategory();
    }

    sortMoreCategories(navItems: any, moreCategories: any) {
        const sortedMoreArray: any = [];
        navItems.forEach((navItem: any) => {
            const navFilteredItem: any = moreCategories.filter((moreItem: any) => {
                return moreItem.categoryid === navItem.categoryid;
            });
            if (navFilteredItem && navFilteredItem.length > 0) {
                sortedMoreArray.push(navFilteredItem[0]);
            }
        });

        return sortedMoreArray;
    }
    get liveCasinoLoungeConfig() {
        return this.configProviderService.provideLiveCasinoLoungeConfig();
    }

    get isLiveCasinoLounge(): boolean {
        return this.liveCasinoLoungeConfig.enabled && this.liveCasinoLoungeConfig?.lobbyType === this.lobbyType;
    }

    private deferAdjustNavScroll(): void {
        requestAnimationFrame(() => {
            setTimeout(() => this.adjustNavContainerScroll(), 200);
        });
    }

    private adjustNavContainerScroll(): void {
        const navElement = this.mobileNavigation?.nativeElement;
        if (!navElement) return;

        const activeItem = navElement.querySelector('.nav-li.active') as HTMLElement;
        const noScrollNeeded = !activeItem && navElement.scrollWidth <= navElement.clientWidth;
        if (noScrollNeeded) return;

        let offsetLeft = 0;

        if (activeItem) {
            const activeRightEdge = activeItem.offsetLeft + activeItem.clientWidth;
            const containerWidth = navElement.clientWidth;

            const isOverflowing = activeRightEdge >= containerWidth;
            if (isOverflowing) {
                offsetLeft = Math.max(this.DEFAULT_OFFSET, activeRightEdge - containerWidth);
            }
        }

        const firstChild = navElement?.children[0] as HTMLElement;
        if (firstChild) {
            firstChild.scrollTo({
                left: offsetLeft,
                behavior: 'smooth',
            });
        }
    }

    setActiveMobile(categoryMobile: string) {
        if (this.selectedUrl) {
            this.currentUrl = this.navigation.location.baseUrl() + this.navigation.location.path();
        }
        if (this.categoryType === categoryMobile) return;

        this.categoryType = categoryMobile;
        if (this.enableFixedMobileNavigation) {
            let index, category;
            if (this.mobileNavigation && this.mobileNavigation.nativeElement && this.mobileNavigation.nativeElement.children.length > 0) {
                for (index = 0; index < this.mobileNavigation.nativeElement.children[0].children.length; index++) {
                    category = this.mobileNavigation.nativeElement.children[0].children[index];
                    category.classList.remove('active');

                    if (
                        this.isLiveCasinoLounge &&
                        categoryMobile !== this.liveCasinoLoungeConfig.defaultCategoryId &&
                        categoryMobile.indexOf(this.liveCasinoLoungeConfig.defaultCategoryId) > -1
                    )
                        categoryMobile = this.liveCasinoLoungeConfig.defaultCategoryId;

                    if (category?.id?.toLowerCase() === categoryMobile?.toLowerCase()) {
                        category.classList.add('active');
                    }
                    if (this.enablePillsSubNavigation) {
                        const NavigationUrl = this.navigation.location.baseUrl() + this.navigation.location.path();
                        if (category?.getAttribute('routeurl') == NavigationUrl) {
                            category.classList.add('active');
                        }
                    }
                }
            }
        }
    }

    setActiveCategory() {
        let setMoreActive = false,
            foundActive = false,
            index,
            category: any = null;
        const navCategories = this.deskNav && this.deskNav.nativeElement && this.deskNav.nativeElement.children.length > 0;
        this.currentUrl = this.navigation.location.baseUrl() + this.navigation.location.path();
        const isMoreCategories =
            navCategories &&
            this.deskNav.nativeElement.children[0].children.moregameslist &&
            this.deskNav.nativeElement.children[1] &&
            this.deskNav.nativeElement.children[1].children &&
            this.deskNav.nativeElement.children[1].children.length >= 1;
        if (navCategories) {
            for (index = 0; index < this.deskNav.nativeElement.children[0].children.length; index++) {
                category = this.deskNav.nativeElement.children[0].children[index];
                if (!category.classList.contains('from-extended-menu-right')) {
                    category.classList.remove('active');
                }
                let categoryRoute = this.categoryRoute;
                if (
                    this.isLiveCasinoLounge &&
                    categoryRoute !== this.liveCasinoLoungeConfig.defaultCategoryId &&
                    categoryRoute.indexOf(this.liveCasinoLoungeConfig.defaultCategoryId) > -1
                )
                    categoryRoute = this.liveCasinoLoungeConfig.defaultCategoryId;
                if (
                    categoryRoute &&
                    category?.id?.toLowerCase() === categoryRoute?.toLowerCase() &&
                    index < this.deskNav.nativeElement.children[0].children.length - this.deskNav.nativeElement.children[1].children.length
                ) {
                    category.classList.add('active');
                    foundActive = true;
                }
            }
        }
        // let isMoreCategories = navCategories && this.deskNav.nativeElement.children[0].children.moregameslist && this.deskNav.nativeElement.children[1] &&
        //     this.deskNav.nativeElement.children[1].children && this.deskNav.nativeElement.children[1].children.length >= 1;
        if (isMoreCategories) {
            for (index = 0; index < this.deskNav.nativeElement.children[1].children.length; index++) {
                category = this.deskNav.nativeElement.children[1].children[index];
                category.classList.remove('border-nav-active');
                if (!foundActive && category?.id?.toLowerCase() === this.categoryRoute?.toLowerCase()) {
                    category.classList.add('border-nav-active');
                    foundActive = true;
                    setMoreActive = true;
                }
            }
        }

        if (!foundActive && navCategories) {
            let tempCategory = this.casinoLobbyService.getCategoryInfo(this.lobbyType, this.categoryRoute);
            while (tempCategory && tempCategory.parentCategoryType) {
                if (this.deskNav.nativeElement.children[1].children[tempCategory.parentCategoryType]) {
                    this.deskNav.nativeElement.children[1].children[tempCategory.parentCategoryType].classList.add('active');
                    foundActive = true;
                    break;
                } else if (isMoreCategories && this.deskNav.nativeElement.children[1]!.children[tempCategory.parentCategoryType]) {
                    this.deskNav.nativeElement.children[1].children[tempCategory.parentCategoryType].classList.add('border-nav-active');
                    foundActive = true;
                    setMoreActive = true;
                    break;
                }
                tempCategory = this.casinoLobbyService.getCategoryInfo(this.lobbyType, tempCategory.parentCategoryType);
            }
        }
        this.isMoreActive = setMoreActive;
    }

    hideMoreCategoryDropdown(hideDropDown: boolean) {
        this.hideMore = hideDropDown;
    }

    smartBannerListExistsChanged(isSbListExists: any) {
        this.smartBannersExists = isSbListExists;
    }
    smartBannerStatusChanged(isOpened: boolean) {
        this.smartBannerOpened = isOpened;
    }

    categoryTracking(event: any, categoryIndex: any, categoryType: any, fromMore: boolean = false) {
        const activeCategory = this.casinoManager.getActiveCategory();
        if (categoryType == activeCategory) {
            return;
        }
        this.isMoreActive = false;
        const previousUrl = window.location.href;
        const array = previousUrl.split('/');
        let lastsegment = array[array.length - 1];
        if (lastsegment == 'casino' || this.isTouch) {
            lastsegment = this.casinoManager.getDefaultCategoryType();
        }
        this.tracking.updateDataLayer({ 'page.name': categoryType, 'eventName': 'pageView', 'c15': '?source=' + lastsegment });
        if (fromMore) {
            this.hideMore = true;
            this.isMoreActive = true;
        }
        let flag: string = '';
        if (categoryType === this.discoverFeedLmtkey) {
            if (!this.displayDiscoverSticker) {
                flag = 'No Badge';
            } else {
                if (this.isBadgeTypeIcon) {
                    flag = 'Star Badge';
                } else if (this.isBadgeTypeText) {
                    flag = 'New Badge';
                }
            }
            this.tracking.triggerEvent('Event.NavigationMenus', {
                'page.navigationMenus': 'SubNav_Discover_' + flag,
            });
        }

        if (event) {
            event.stopPropagation();
        }
        this.trackingEntireNavigation(categoryIndex, categoryType);
    }
    trackingEntireNavigation(categoryIndex: any, categoryType: any) {
        const lobbyData: any = this.casinoLobbyService.getLobbyBasedOnLobbyType(this.lobbyType);
        if (categoryType && categoryIndex) {
            this.tracking.triggerEvent('Event.Tracking', {
                'component.CategoryEvent': 'navigation',
                'component.LabelEvent': 'quick nav',
                'component.ActionEvent': 'click',
                'component.PositionEvent': categoryIndex,
                'component.LocationEvent': 'not applicable',
                'component.EventDetails': categoryType,
                'component.URLClicked': 'not applicable',
                'casino.lobbyName': lobbyData?.lbyTempName ? lobbyData?.lbyTempName : null,
                'casino.lobbySource': lobbyData?.lbyTargetType ? lobbyData?.lbyTargetType : null,
                'casino.optimoveSegment': lobbyData?.optSegName ? lobbyData?.optSegName : null,
            });
        }
    }
    onResize() {
        if (this.isTouch && this.orientation && this.orientation._value == 'landscape') {
            this.adjustNavOnLandscapeMode();
        }
        if (this.deviceService.windowWidth() >= 768) {
            this.updateNavItems();
        }
    }

    @HostListener('document:click', ['$event'])
    clickout(event: any, hideDropDown: boolean = true) {
        if (this.navigationBar.nativeElement.contains(event.target)) {
        } else if (!this.navigationBar.nativeElement.contains(event.target)) {
            this.hideMore = hideDropDown;
            this.showLastLevelCategoryDropdown = !hideDropDown;
        }
    }

    adjustNav() {
        let sbHeight: number;
        if (!this.isMobileWidth()) {
            sbHeight = 78;
        } else {
            sbHeight = 75;
        }
        const hdrNavEle = this.headerService.hasHeaderElement();
        if (hdrNavEle) {
            const hdrNavEleHeight = this.headerService.headerElementRect().height;

            const csNavHeight = hdrNavEleHeight + sbHeight;
            if (document.getElementsByTagName('html')[0].classList.contains('smartBannerEnable')) {
                document.querySelector(this.stickyInputQueryElement)?.setAttribute('style', 'top:' + csNavHeight + 'px;');
            }
        }
    }

    setVanillaActiveHeader() {
        let iscategoryMatchedfromDynacon: boolean = false;
        if (this.categoryHeaderHighLight && this.categoryHeaderHighLight.length > 0) {
            this.categoryHeaderHighLight.forEach((item: any) => {
                if (this.categoryRoute && this.categoryRoute?.toLowerCase() == item?.categoryName?.toLowerCase()) {
                    this.headerServiceObservable = this.headerService.whenReady.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
                        this.headerService.highlightProduct(item?.product?.toLowerCase());
                    });
                    this.bottomNavService.whenReady.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
                        if (this.enablePillsSubNavigation) {
                            this.menuService.setActive(MenuSection.BottomNav, 'casino_epcot');
                        } else {
                            this.bottomNavService.setActiveItem(item?.product?.toLowerCase());
                        }
                    });
                    iscategoryMatchedfromDynacon = true;
                }
            });
        }
        if (!iscategoryMatchedfromDynacon) {
            this.headerService.whenReady.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
                this.headerService.highlightProduct(this.lobbyProduct?.toLowerCase());
            });
            this.bottomNavService.whenReady.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
                if (this.enablePillsSubNavigation && this.lobbyProduct?.toLowerCase() == 'games') {
                    this.menuService.setActive(MenuSection.BottomNav, 'casino_epcot');
                } else {
                    this.bottomNavService.setActiveItem(this.lobbyProduct?.toLowerCase());
                }
            });
        }
    }

    getActiveCategoryStatus(category: any) {
        if (category && this.currentCategoryInfo) {
            return category.categoryid === this.currentCategoryInfo.categoryid;
        }
        return false;
    }
    evalSubNavDisplay(subNavDsl: string) {
        this.dslService
            .evaluateExpression(subNavDsl)
            ?.pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((value: boolean) => {
                this.enableSubNav = value;
            });
    }

    private adjustNavOnLandscapeMode() {
        if (
            window.matchMedia('(orientation:landscape)').matches &&
            this.isTouch &&
            this.deviceService.windowWidth() < 480 &&
            !this.enableFixedMobileNavigation
        ) {
            document.getElementsByTagName('html')[0].classList.add('add-sticky-navigation');
        } else {
            if (this.headerService.hasHeaderElement()) {
                document.getElementsByTagName('html')[0].classList.remove('add-sticky-navigation');
                if (document.querySelector(this.stickyInputQueryElement)) {
                    document
                        .querySelector(this.stickyInputQueryElement)
                        ?.setAttribute('style', 'top:' + this.headerService.headerComponentRect().height + 'px;');
                }
                this.adjustNav();
            }
        }
    }
}

export class ExtendedTopMenutoRight {
    categoryname: string;
    url: string;
    pathname: string;
    categoryid: string;
    sitecoreData: any = {};
    isNavigationCategory: boolean;
    isExtendedTopMenuItem: boolean;
    condition: string;
    index: number;
    fromExtendedMenuRight: boolean;
    Flagname: string;
    showInNavExtendedTopMenu: boolean;
    categoryType: string;
    constructor() {
        this.isExtendedTopMenuItem = true;
    }
}
